export default "__VITE_ASSET__7JAFBwSi__"